:host {
    display: block;

    button {
        all: unset;
        background-color: $color-white;
        height: 80px;
        width: 80px;
        border-radius: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        overflow: hidden;
        position: relative;
        box-shadow: 0 2px 15px -5px #000;
        color: $color-red;
        border: 1px solid $color-red;
        max-width: 80px;
        transition: max-width 500ms;
    }

    span {
        @include typo-ws-copy-l;

        font-size: 28px;
        line-height: 36px;
        max-width: 0;
        opacity: 0;
        overflow: hidden;
        transition: opacity 400ms;
        white-space: nowrap;
    }
}

:host(:hover),
:host([expanded]) {
    button {
        width: auto;
        max-width: 350px;
        gap: 14px;
        justify-content: flex-end;
    }

    span {
        max-width: unset;
        padding-left: 37px;
        opacity: 1;
    }

    .svg {
        margin-right: 16px;
    }
}

:host(:active) {
    button {
        background-color: $color-red;
        color: $color-white;
    }
}

:host([expanded]) {
    overflow: unset;
}

@include mq-1 {
    :host {
        button {
            height: 60px;
            width: 60px;
        }

        .svg {
            width: 36px;
        }
    }

    :host(:hover),
    :host([expanded]) {
        button {
            gap: 9px;

            span {
                padding-left: 24px;
            }

            .svg {
                margin-right: 15px;
            }
        }
    }
}
